export class Deferred {
	private isOpen = false;
	private isOpeningPromisePresent: Promise<void> | false = false;
	private isReadyCallback: (value?: void | PromiseLike<void>) => void = () => undefined;

	public open(): void {
		this.isOpen = true;
		this.isReadyCallback();
		this.reset();
	}

	public close(): void {
		this.isOpen = false;
		this.reset();
	}

	private reset(): void {
		this.isReadyCallback = (): any => undefined;
		this.isOpeningPromisePresent = false;
	}

	public untilOpen(): Promise<void> {
		// If not open, start opening, otherwise wait
		return this.isOpeningPromisePresent
			? this.isOpeningPromisePresent
			: (this.isOpeningPromisePresent = new Promise<void>(
				(resolve: (value?: void | PromiseLike<void>) => void): void => {
					// If ready - resolve, if not - set resolve to
					if (this.isOpen) {
						resolve();
					} else {
						this.isReadyCallback = resolve;
					}
				},
			));
	}
}
